// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3lZcb","errorLogs":"EditorFooter_errorLogs__3WJed"};